export const AdGroupCriterion = {
  properties: {
    CriterionType: {
      'bulk-upload-header': 'Type',
      'bulk-upload-mapper': function (value) {
        switch (value) {
          case 'Device':
            return 'AdGroup DeviceOS Criterion';
          case 'Age':
            return 'AdGroup Age Criterion';
          case 'NegativeAge':
            return 'AdGroup Negative Age Criterion';
          case 'Gender':
            return 'AdGroup Gender Criterion';
          case 'NegativeGender':
            return 'AdGroup Negative Gender Criterion';
          case 'Radius':
            return 'AdGroup Radius Criterion';
          case 'Location':
            return 'AdGroup Location Criterion';
          case 'NegativeLocation':
            return 'AdGroup Negative Location Criterion';
          case 'LocationIntentCriterion':
            return 'AdGroup Location Intent Criterion';
          case 'DayTime':
            return 'AdGroup Day Time Criterion';
          case 'CompanyName':
            return 'Ad Group Company Name Criterion';
          case 'NegativeCompanyName':
            return 'Ad Group Negative Company Name Criterion';
          case 'Industry':
            return 'Ad Group Industry Criterion';
          case 'NegativeIndustry':
            return 'Ad Group Negative Industry Criterion';
          case 'JobFunction':
            return 'Ad Group Job Function Criterion';
          case 'NegativeJobFunction':
            return 'Ad Group Negative Job Function Criterion';
          case 'AdvanceBookingWindow':
            return 'Ad Group Advance Booking Window Criterion';
          case 'CheckInDay':
            return 'Ad Group Check In Day Criterion';
          case 'LengthofStay':
            return 'Ad Group Length of Stay Criterion';
          case 'CheckInDate':
            return 'Ad Group Check In Date Criterion';
          case 'DateSelectionType':
            return 'Ad Group Hotel Date Selection Type Criterion';
          case 'ContextualTarget':
            return 'Ad Group Contextual Target';
          case 'Genre':
            return 'AdGroup Genre Criterion';
          case 'AdGroupPlacementCriterion':
            return 'AdGroup Placement Criterion';
          default:
            return 'AdGroup Unknown Criterion';
        }
      },
    },
    CampaignName: {
      'bulk-upload-header': 'Campaign',
    },
    AdGroupName: {
      'bulk-upload-header': 'Ad Group',
    },
  },
};
